import { AutogenLayoutEdiCommodityList } from "./autogen/AutogenLayoutEdiCommodityList";

export class EdiCommodityList extends AutogenLayoutEdiCommodityList {

}
